import { FC, Fragment } from 'react';
import { User } from 'react-feather';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Flex } from '../';

type AccountImageProps = {
  profileURL: string;
  userName: string;
};

const OuterDottedBorder = styled.div`
  border: ${props => `2px dotted ${props.theme.colors.primary}`};
  border-radius: 25px;
  border-style: dotted;
  height: 50px;
  margin-right: 10px;
  width: 50px;
`;

const InnerImageBounds = styled.div`
  background: ${props => props.theme.colors.primary};
  border-radius: 24px;
  color: #fff;
  height: 48px;
  margin: 1px;
  width: 48px;
`;

const UserNameSpan = styled.span`
  color: #000;
  font-size: 1.2em;
  margin-bottom: 8px;
`;

const AccountImage: FC<AccountImageProps> = ({ profileURL, userName }) => {
  return (
    <Fragment>
      <OuterDottedBorder>
        <InnerImageBounds>
          <User
            style={{
              display: 'block',
              height: '100%',
              margin: '0 auto',
              strokeWidth: '1px',
              verticalAlign: 'middle',
              width: '35px',
            }}
          />
        </InnerImageBounds>
      </OuterDottedBorder>
      <Flex direction="column" size="1" justify="space-between">
        <UserNameSpan>{userName}</UserNameSpan>
        <Link to={profileURL} style={{ fontSize: '0.7em', color: '#808080' }}>
          View Profile
        </Link>
      </Flex>
    </Fragment>
  );
};

export default AccountImage;
